/*
 * @Description: 配置服务，用于动态读取配置文件
 * @Date: 2025-08-21
 */
import axios from 'axios';

// 配置服务类
class ConfigService {
  constructor() {
    this.config = null;
    this.isLoading = false;
    this.loadPromise = null;
  }

  // 加载配置
  async loadConfig() {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.isLoading = true;
    this.loadPromise = new Promise(async (resolve, reject) => {
      try {
        // 使用根绝对路径加载配置文件，避免在深层路由页面刷新时相对路径解析错误
        const response = await fetch('/config/Serverconfig.json');
        if (!response.ok) {
          throw new Error(`Failed to load config: ${response.status}`);
        }
        this.config = await response.json();
        this.isLoading = false;
        resolve(this.config);
      } catch (error) {
        console.error('Error loading config:', error);
        this.isLoading = false;
        // 加载失败时回退到同域相对路径，由网关/反向代理转发，不再硬编码旧环境地址
        this.config = {
          baseURL: '/api/v1'
        };
        resolve(this.config);
      }
    });

    return this.loadPromise;
  }

  // 获取配置
  async getConfig() {
    if (!this.config && !this.isLoading) {
      await this.loadConfig();
    } else if (this.isLoading) {
      await this.loadPromise;
    }
    return this.config;
  }

  // 获取特定配置项
  async getConfigItem(key) {
    const config = await this.getConfig();
    return config[key];
  }

  // 应用配置到axios
  async applyAxiosConfig() {
    const config = await this.getConfig();
    if (config && config.baseURL) {
      axios.defaults.baseURL = config.baseURL;
    }
    return config;
  }
}

// 导出单例
export default new ConfigService();